import $device from '@/lib/device';
import qs from 'query-string';
import { applyDownloadApp } from '@/services/rpc/download';
import { webSlsDownloadLogger } from '@/lib/log/sls/slsDownloadLog';
import { downloadUrl, OpenType } from '@/constant/download';

export const initEntry = (fn: Function): void => {
  const qsParams = qs.parse(window.location.search);
  const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } =
    qsParams;
  const { isIPhone, isAndroid, isWeChat, isPc } = $device;

  /**
   * 1. 空白承载页
   * 2. iOS
   * 3. 非WeChat
   */
  if (qsParams.open === OpenType.BLANK && isIPhone && !isWeChat) {
    jumpToDownload(downloadUrl.iphone);
    return;
  }

  /**
   * 1. 空白承载页
   * 2. Android
   * 3. 非WeChat
   */
  if (qsParams.open === OpenType.BLANK && isAndroid && !isWeChat) {
    jumpToDownload(downloadUrl.android);
    return;
  }

  if (isPc) {
    const utmPrams = qs.stringify({
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
    });
    const query = utmPrams ? '?' + utmPrams : '';
    jumpToDownload(downloadUrl.web + query);
    return;
  }

  // 显示下载承载页
  fn && fn();
};

/**
 * 跳转至下载页
 * @param url
 */
const jumpToDownload = (url: string) => {
  const qsParams = qs.parse(window.location.search);
  const { utm_source, mid, kid } = qsParams;
  let source = utm_source instanceof Array ? utm_source[0] : utm_source;

  // 埋点
  webSlsDownloadLogger('app_download_auto_jump_appStore');

  // tiktok & instagram 投放归因
  if (source) {
    const featureParams: any = {
      ...qsParams,
      url: location.href,
      ua: navigator.userAgent,
    };
    if (mid) {
      featureParams.mid = mid instanceof Array ? mid.join(',') : mid;
    }
    if (kid) {
      featureParams.kid = kid instanceof Array ? kid.join(',') : kid;
    }
    let feature = JSON.stringify(featureParams);

    // 归因请求
    const reqParams = {
      feature,
      source: (source as string) || '',
    };
    applyDownloadApp(reqParams).catch(err => {
      console.error(err);
    });
  }
  window.location.href = url;
};
